import './LargeLink.css.proxy.js';
/* src/components/car/LargeLink.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_text,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text,
	toggle_class
} from "../../web_modules/svelte/internal.js";

function create_if_block_3(ctx) {
	let li;
	let t_value = (/*car*/ ctx[0].category.name || "カテゴリーなし") + "";
	let t;

	return {
		c() {
			li = element("li");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			t = claim_text(li_nodes, t_value);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li, "class", "category svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && t_value !== (t_value = (/*car*/ ctx[0].category.name || "カテゴリーなし") + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (5:371) {#if car.maker}
function create_if_block_2(ctx) {
	let li;
	let t0;
	let t1_value = (/*car*/ ctx[0].maker.name || "") + "";
	let t1;

	return {
		c() {
			li = element("li");
			t0 = text("メーカー： ");
			t1 = text(t1_value);
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			t0 = claim_text(li_nodes, "メーカー： ");
			t1 = claim_text(li_nodes, t1_value);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li, "class", "svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t0);
			append(li, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && t1_value !== (t1_value = (/*car*/ ctx[0].maker.name || "") + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (5:588) {:else}
function create_else_block_1(ctx) {
	let p;
	let span0;
	let t0;
	let strong;
	let t1_value = /*car*/ ctx[0].price + "";
	let t1;
	let span1;
	let t2;

	return {
		c() {
			p = element("p");
			span0 = element("span");
			t0 = text("本体価格");
			strong = element("strong");
			t1 = text(t1_value);
			span1 = element("span");
			t2 = text("万円");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			span0 = claim_element(p_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "本体価格");
			span0_nodes.forEach(detach);
			strong = claim_element(p_nodes, "STRONG", { class: true });
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, t1_value);
			strong_nodes.forEach(detach);
			span1 = claim_element(p_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, "万円");
			span1_nodes.forEach(detach);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(strong, "class", "svelte-tvkaiv");
			attr(p, "class", "price svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, span0);
			append(span0, t0);
			append(p, strong);
			append(strong, t1);
			append(p, span1);
			append(span1, t2);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && t1_value !== (t1_value = /*car*/ ctx[0].price + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (5:514) {#if !car.price}
function create_if_block_1(ctx) {
	let p;
	let span;
	let t0;
	let strong;
	let t1;

	return {
		c() {
			p = element("p");
			span = element("span");
			t0 = text("本体価格");
			strong = element("strong");
			t1 = text("ASK");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			span = claim_element(p_nodes, "SPAN", {});
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, "本体価格");
			span_nodes.forEach(detach);
			strong = claim_element(p_nodes, "STRONG", { class: true });
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, "ASK");
			strong_nodes.forEach(detach);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(strong, "class", "svelte-tvkaiv");
			attr(p, "class", "price svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, span);
			append(span, t0);
			append(p, strong);
			append(strong, t1);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (5:781) {:else}
function create_else_block(ctx) {
	let p;
	let span0;
	let t0;
	let strong;
	let t1_value = /*car*/ ctx[0].totalPrice + "";
	let t1;
	let span1;
	let t2;

	return {
		c() {
			p = element("p");
			span0 = element("span");
			t0 = text("支払総額");
			strong = element("strong");
			t1 = text(t1_value);
			span1 = element("span");
			t2 = text("万円");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			span0 = claim_element(p_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "支払総額");
			span0_nodes.forEach(detach);
			strong = claim_element(p_nodes, "STRONG", { class: true });
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, t1_value);
			strong_nodes.forEach(detach);
			span1 = claim_element(p_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, "万円");
			span1_nodes.forEach(detach);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(strong, "class", "svelte-tvkaiv");
			attr(p, "class", "total-price svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, span0);
			append(span0, t0);
			append(p, strong);
			append(strong, t1);
			append(p, span1);
			append(span1, t2);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && t1_value !== (t1_value = /*car*/ ctx[0].totalPrice + "")) set_data(t1, t1_value);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (5:681) {#if !car.totalPrice}
function create_if_block(ctx) {
	let p;
	let span0;
	let t0;
	let strong;
	let t1;
	let span1;
	let t2;

	return {
		c() {
			p = element("p");
			span0 = element("span");
			t0 = text("支払総額");
			strong = element("strong");
			t1 = text("ASK");
			span1 = element("span");
			t2 = text("万円");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			span0 = claim_element(p_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, "支払総額");
			span0_nodes.forEach(detach);
			strong = claim_element(p_nodes, "STRONG", { class: true });
			var strong_nodes = children(strong);
			t1 = claim_text(strong_nodes, "ASK");
			strong_nodes.forEach(detach);
			span1 = claim_element(p_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			t2 = claim_text(span1_nodes, "万円");
			span1_nodes.forEach(detach);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(strong, "class", "svelte-tvkaiv");
			attr(p, "class", "total-price svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, span0);
			append(span0, t0);
			append(p, strong);
			append(strong, t1);
			append(p, span1);
			append(span1, t2);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let a;
	let figure;
	let img;
	let img_src_value;
	let div;
	let ul0;
	let li0;
	let t0_value = (/*car*/ ctx[0].sold ? "成約済み" : "販売中") + "";
	let t0;
	let h3;
	let t1_value = /*car*/ ctx[0].title + "";
	let t1;
	let ul1;
	let li1;
	let t2;
	let t3_value = (/*car*/ ctx[0].modelYear || "- ") + "";
	let t3;
	let t4;
	let li2;
	let t5;
	let t6_value = (/*car*/ ctx[0].mileage || "- ") + "";
	let t6;
	let t7;
	let hr;
	let if_block2_anchor;
	let a_href_value;
	let if_block0 = /*car*/ ctx[0].category && create_if_block_3(ctx);
	let if_block1 = /*car*/ ctx[0].maker && create_if_block_2(ctx);

	function select_block_type(ctx, dirty) {
		if (!/*car*/ ctx[0].price) return create_if_block_1;
		return create_else_block_1;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block2 = current_block_type(ctx);

	function select_block_type_1(ctx, dirty) {
		if (!/*car*/ ctx[0].totalPrice) return create_if_block;
		return create_else_block;
	}

	let current_block_type_1 = select_block_type_1(ctx, -1);
	let if_block3 = current_block_type_1(ctx);

	return {
		c() {
			a = element("a");
			figure = element("figure");
			img = element("img");
			div = element("div");
			ul0 = element("ul");
			li0 = element("li");
			t0 = text(t0_value);
			if (if_block0) if_block0.c();
			h3 = element("h3");
			t1 = text(t1_value);
			ul1 = element("ul");
			if (if_block1) if_block1.c();
			li1 = element("li");
			t2 = text("年　　式： ");
			t3 = text(t3_value);
			t4 = text("年");
			li2 = element("li");
			t5 = text("走行距離： ");
			t6 = text(t6_value);
			t7 = text("km");
			hr = element("hr");
			if_block2.c();
			if_block2_anchor = empty();
			if_block3.c();
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			figure = claim_element(a_nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, loading: true, class: true });
			figure_nodes.forEach(detach);
			div = claim_element(a_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			ul0 = claim_element(div_nodes, "UL", { class: true });
			var ul0_nodes = children(ul0);
			li0 = claim_element(ul0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t0 = claim_text(li0_nodes, t0_value);
			li0_nodes.forEach(detach);
			if (if_block0) if_block0.l(ul0_nodes);
			ul0_nodes.forEach(detach);
			h3 = claim_element(div_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t1 = claim_text(h3_nodes, t1_value);
			h3_nodes.forEach(detach);
			ul1 = claim_element(div_nodes, "UL", { class: true });
			var ul1_nodes = children(ul1);
			if (if_block1) if_block1.l(ul1_nodes);
			li1 = claim_element(ul1_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			t2 = claim_text(li1_nodes, "年　　式： ");
			t3 = claim_text(li1_nodes, t3_value);
			t4 = claim_text(li1_nodes, "年");
			li1_nodes.forEach(detach);
			li2 = claim_element(ul1_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			t5 = claim_text(li2_nodes, "走行距離： ");
			t6 = claim_text(li2_nodes, t6_value);
			t7 = claim_text(li2_nodes, "km");
			li2_nodes.forEach(detach);
			ul1_nodes.forEach(detach);
			hr = claim_element(div_nodes, "HR", { class: true });
			if_block2.l(div_nodes);
			if_block2_anchor = empty();
			if_block3.l(div_nodes);
			div_nodes.forEach(detach);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*car*/ ctx[0].image?.getSized("thumbnail") || "/images/keyvisual.jpg")) attr(img, "src", img_src_value);
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-tvkaiv");
			attr(figure, "class", "svelte-tvkaiv");
			attr(li0, "class", "status svelte-tvkaiv");
			toggle_class(li0, "sold", /*car*/ ctx[0].sold);
			attr(ul0, "class", "tags svelte-tvkaiv");
			attr(h3, "class", "svelte-tvkaiv");
			attr(li1, "class", "svelte-tvkaiv");
			attr(li2, "class", "svelte-tvkaiv");
			attr(ul1, "class", "details svelte-tvkaiv");
			attr(hr, "class", "svelte-tvkaiv");
			attr(div, "class", "contents svelte-tvkaiv");
			attr(a, "href", a_href_value = "/stock/" + /*car*/ ctx[0].id);
			attr(a, "class", "svelte-tvkaiv");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, figure);
			append(figure, img);
			append(a, div);
			append(div, ul0);
			append(ul0, li0);
			append(li0, t0);
			if (if_block0) if_block0.m(ul0, null);
			append(div, h3);
			append(h3, t1);
			append(div, ul1);
			if (if_block1) if_block1.m(ul1, null);
			append(ul1, li1);
			append(li1, t2);
			append(li1, t3);
			append(li1, t4);
			append(ul1, li2);
			append(li2, t5);
			append(li2, t6);
			append(li2, t7);
			append(div, hr);
			if_block2.m(div, null);
			append(div, if_block2_anchor);
			if_block3.m(div, null);
		},
		p(ctx, [dirty]) {
			if (dirty & /*car*/ 1 && img.src !== (img_src_value = /*car*/ ctx[0].image?.getSized("thumbnail") || "/images/keyvisual.jpg")) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*car*/ 1 && t0_value !== (t0_value = (/*car*/ ctx[0].sold ? "成約済み" : "販売中") + "")) set_data(t0, t0_value);

			if (dirty & /*car*/ 1) {
				toggle_class(li0, "sold", /*car*/ ctx[0].sold);
			}

			if (/*car*/ ctx[0].category) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					if_block0.m(ul0, null);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*car*/ 1 && t1_value !== (t1_value = /*car*/ ctx[0].title + "")) set_data(t1, t1_value);

			if (/*car*/ ctx[0].maker) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					if_block1.m(ul1, li1);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*car*/ 1 && t3_value !== (t3_value = (/*car*/ ctx[0].modelYear || "- ") + "")) set_data(t3, t3_value);
			if (dirty & /*car*/ 1 && t6_value !== (t6_value = (/*car*/ ctx[0].mileage || "- ") + "")) set_data(t6, t6_value);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block2) {
				if_block2.p(ctx, dirty);
			} else {
				if_block2.d(1);
				if_block2 = current_block_type(ctx);

				if (if_block2) {
					if_block2.c();
					if_block2.m(div, if_block2_anchor);
				}
			}

			if (current_block_type_1 === (current_block_type_1 = select_block_type_1(ctx, dirty)) && if_block3) {
				if_block3.p(ctx, dirty);
			} else {
				if_block3.d(1);
				if_block3 = current_block_type_1(ctx);

				if (if_block3) {
					if_block3.c();
					if_block3.m(div, null);
				}
			}

			if (dirty & /*car*/ 1 && a_href_value !== (a_href_value = "/stock/" + /*car*/ ctx[0].id)) {
				attr(a, "href", a_href_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(a);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if_block2.d();
			if_block3.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	
	let { car } = $$props;

	$$self.$$set = $$props => {
		if ("car" in $$props) $$invalidate(0, car = $$props.car);
	};

	return [car];
}

class LargeLink extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { car: 0 });
	}
}

export default LargeLink;
//# sourceMappingURL=LargeLink.js.map
